module.exports = __webpack_public_path__ + "static/media/adminDashboardGreen.6a837c82.svg";